import axios from "infra/http";
import { useMutation } from "react-query";
import { showSuccess } from "infra/helpers/alerta";

function useConfirmarAutorizacaoPortariaLista() {
  return useMutation(
    (query: { id: string; eventoPessoaId: string }) => {
      return axios.post(
        `/v1/portaria/${query.id}/pessoas/${query.eventoPessoaId}/confirmar-chegada`,
        { query }
      );
    },
    {
      onSuccess() {
        showSuccess("Autorização de convidado confirmada com sucesso!");
      },
    }
  );
}

export default useConfirmarAutorizacaoPortariaLista;
